module.exports = __webpack_public_path__ + "static/media/activate-key-white-label.37c10f3d.svg";